<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-16 11:23:17
 * @FilePath: \mrc-ess-fronted\src\Layout\components\ImportIn\Files_ImportIn.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-18 14:30:08
-->
<template>
  <normalDialog
    :dialog="show"
    width="680"
    :title="$t('label_essweb_system_operation_dialog_ImportInTitle')"
    maxWidth="680"
    @close="closeDialog"
  >
    <template v-slot:content>
      <Stepper :curStep="curStep" :items="stepper" backgroundColor="white">
        <template v-slot:content-1>
          <v-row>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12" v-if="options">
              <FileDragUpdate
                ref="upload"
                :single="!options.multiple"
                :type="
                  options.type ? (options.type ? 'client' : 'admin') : 'admin'
                "
                :url="options.api"
                :reload="toReload"
                :tempplateUrl="options.templateUrl"
                @change="onChange"
                :title="
                  options.title
                    ? options.title
                    : $t('label_essweb_system_operation_dialog_fileLabel')
                "
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:content-2>
          <v-sheet height="300" class="text-center d-flex align-center">
            <v-sheet v-if="isSuccess" class="text-center max-width">
              <span>{{
                $t(
                  "message_essweb_system_operation_dialog_importInSuccessLabel"
                )
              }}</span>
            </v-sheet>
            <v-sheet v-else class="text-center max-width">
              <span>{{
                $t("message_essweb_system_operation_dialog_importInFailLabel")
              }}</span
              ><br />
              <v-btn
                text
                :ripple="false"
                small
                rounded
                depressed
                color="primary"
                @click="showMessage = true"
                class="primary--text text-decoration-underline"
                >{{
                  $t(
                    "label_essweb_system_operation_dialog_errorMessageBtnLabel"
                  )
                }}</v-btn
              >
            </v-sheet>
          </v-sheet>
        </template>
      </Stepper>
    </template>
    <template v-slot:actions>
      <CardActions
        :saveBtn="curStep != 1"
        :saveText="text"
        :okBtnDisabled="curStep == 1"
        @save="curStep == 2 && !isSuccess ? toReUpLoad() : closeDialog()"
        @cancel="closeDialog"
      />
      <ErrorMessage
        :show="showMessage"
        @close="showMessage = false"
        :items="fileData"
        :downloadUrl="downloadUrl"
      />
    </template>
  </normalDialog>
</template>
<script>
import ErrorMessage from "@/Layout/components/ImportIn/ErrorMessage";
export default {
  name: "ExportIn",
  components: { ErrorMessage },
  props: {
    show: { default: false, type: Boolean },
    options: { default: null, type: Object },
  },
  computed: {
    text() {
      let isd = this.curStep == 2 && !this.isSuccess;
      if (!this.isSuccess) {
        isd = true;
      }
      return isd
        ? "label_essweb_system_operation_dialog_reUploadBtnLabel"
        : "label_Complete";
    },
  },
  watch: {
    show() {
      this.curStep = 1;
    },
  },
  data() {
    return {
      curStep: 1,
      uploadData: null,
      toReload: 123,
      downloadUrl: "",
      isSuccess: false,
      showMessage: false,
      fileData: [],
      stepper: [
        "label_essweb_system_operation_dialog_step_importInLabel",
        "label_essweb_system_operation_dialog_step_resultLabel",
      ],
    };
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    toReUpLoad: function () {
      const that = this;
      this.curStep = 1;
      that.toReload = Math.random() * 10000000;
    },
    showError: function () {
      const that = this;
      this.closeDialog();
      this.$Sleep(500).then(() => {
        that.showMessage = true;
      });
    },
    onSubmit: function () {},
    onChange: function (data) {
      const that = this;
      this.$Sleep(300).then(() => {
        if (data)
          if (data["code"] == 200) {
            that.isSuccess = true;
            that.fileData = data["data"];
            that.curStep = 2;
            //提供两种方式监听上传成功结果
            if (this.options && this.options.success) {
              this.options.success(true);
            } else {
              that.$emit("import", true);
            }
          } else {
            that.isSuccess = false;
            that.fileData = data["data"]["excel_errors"]
              ? data["data"]["excel_errors"]
              : [];
            that.downloadUrl = data["data"]["download_url"]
              ? data["data"]["download_url"]
              : "";
            //提供两种方式监听上传成功结果
            if (this.options && this.options.fail) {
              this.options.fail(false);
            } else {
              that.$emit("import", false);
            }
            that.curStep = 2;
          }
      });
    },
  },
};
</script>